/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetLocationBrandCatalogs200Response,
  ToggleLocationBrandEnabledRequest,
  UpdateLocationBrandCatalogAssignmentRequest,
} from '../models/index';
import {
    GetLocationBrandCatalogs200ResponseFromJSON,
    GetLocationBrandCatalogs200ResponseToJSON,
    ToggleLocationBrandEnabledRequestFromJSON,
    ToggleLocationBrandEnabledRequestToJSON,
    UpdateLocationBrandCatalogAssignmentRequestFromJSON,
    UpdateLocationBrandCatalogAssignmentRequestToJSON,
} from '../models/index';

export interface ToggleLocationBrandEnabledOperationRequest {
    id: string;
    toggleLocationBrandEnabledRequest: ToggleLocationBrandEnabledRequest;
}

export interface UpdateLocationBrandCatalogAssignmentOperationRequest {
    id: string;
    updateLocationBrandCatalogAssignmentRequest: UpdateLocationBrandCatalogAssignmentRequest;
}

/**
 * 
 */
export class LocationBrandsApi extends runtime.BaseAPI {

    /**
     */
    async getLocationBrandCatalogsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocationBrandCatalogs200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/location-brands/catalogs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationBrandCatalogs200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLocationBrandCatalogs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocationBrandCatalogs200Response> {
        const response = await this.getLocationBrandCatalogsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async toggleLocationBrandEnabledRaw(requestParameters: ToggleLocationBrandEnabledOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling toggleLocationBrandEnabled().'
            );
        }

        if (requestParameters['toggleLocationBrandEnabledRequest'] == null) {
            throw new runtime.RequiredError(
                'toggleLocationBrandEnabledRequest',
                'Required parameter "toggleLocationBrandEnabledRequest" was null or undefined when calling toggleLocationBrandEnabled().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/location-brands/{id}/enabled`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ToggleLocationBrandEnabledRequestToJSON(requestParameters['toggleLocationBrandEnabledRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async toggleLocationBrandEnabled(requestParameters: ToggleLocationBrandEnabledOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.toggleLocationBrandEnabledRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationBrandCatalogAssignmentRaw(requestParameters: UpdateLocationBrandCatalogAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLocationBrandCatalogAssignment().'
            );
        }

        if (requestParameters['updateLocationBrandCatalogAssignmentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationBrandCatalogAssignmentRequest',
                'Required parameter "updateLocationBrandCatalogAssignmentRequest" was null or undefined when calling updateLocationBrandCatalogAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/location-brands/{id}/catalog`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationBrandCatalogAssignmentRequestToJSON(requestParameters['updateLocationBrandCatalogAssignmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationBrandCatalogAssignment(requestParameters: UpdateLocationBrandCatalogAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationBrandCatalogAssignmentRaw(requestParameters, initOverrides);
    }

}
